import React from "react";
import { useTranslation } from "react-i18next";
import { Badge, Col, Row } from "reactstrap";

import usePlanFeatures from "../../../hooks/usePlanFeatures";
import {
  PLAN_FEATURE_DISPLAY_ORDER,
  PLAN_FEATURE_LABEL_KEYS,
  PlanFeatureKey,
} from "../../../services/sessionCapabilitiesService";

/**
 * Checklist of plan capabilities on /settings/subscription (doc 10 § 3.0.2).
 */
const PlanFeaturesCard = () => {
  const { t } = useTranslation();
  const {
    features,
    maxServices,
    servicesCount,
    isTrial,
    isLoading,
    can,
  } = usePlanFeatures();

  if (isLoading) {
    return null;
  }

  const keys = PLAN_FEATURE_DISPLAY_ORDER.filter(
    (key) => key in features || PLAN_FEATURE_LABEL_KEYS[key]
  );

  return (
    <div className="mt-4 pt-3 border-top">
      <p className="text-muted mb-2">{t("settings.subscription.features.title")}</p>
      {isTrial ? (
        <p className="small text-success mb-3">
          <i className="ri-sparkling-line me-1" aria-hidden />
          {t("settings.subscription.features.trialActive")}
        </p>
      ) : null}

      {maxServices !== null ? (
        <p className="small text-muted mb-3">
          {t("settings.subscription.features.servicesUsage", {
            current: servicesCount,
            max: maxServices,
          })}
        </p>
      ) : (
        <p className="small text-muted mb-3">
          {t("settings.subscription.features.servicesUnlimited", {
            current: servicesCount,
          })}
        </p>
      )}

      <Row className="g-2">
        {keys.map((key: PlanFeatureKey) => {
          const allowed = can(key);

          return (
            <Col xs={12} sm={6} key={key}>
              <div className="d-flex align-items-center gap-2">
                <i
                  className={
                    allowed
                      ? "ri-checkbox-circle-fill text-success"
                      : "ri-lock-line text-muted"
                  }
                  aria-hidden
                />
                <span className={allowed ? "" : "text-muted"}>
                  {t(PLAN_FEATURE_LABEL_KEYS[key])}
                </span>
                {!allowed ? (
                  <Badge color="warning" className="ms-auto">
                    {t("plan.menu.premiumBadge")}
                  </Badge>
                ) : null}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default PlanFeaturesCard;
